import React, { Component, Fragment } from 'react'
import ErrorDisplayFatal from '../error-display-fatal'
import Appsignal from '@appsignal/javascript'

const appsignal = new Appsignal({
  key: process.env.REACT_APP_APP_SIGNAL_KEY,
  revision: process.env.REACT_APP_BUILD_NUMBER
})

const errorDescription = (
  <Fragment>
    Something unexpected happened in our code. We most likely already know about the issue and are
    working to solve it. It is likely that this is a temporary problem so try refreshing this page
    or try again in a few minutes.
  </Fragment>
)

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  componentDidCatch(error, info) {
    // https://reactjs.org/docs/error-boundaries.html
    this.setState({
      hasError: true,
      error: {
        summary: error.message,
      },
    })

    const span = appsignal.createSpan()
    span.setTags({ error: 'unhandled', local: 'boundary' })
    span.setError(error)

    appsignal.send(span)

    // Log stuff
    console.warn(info.componentStack)
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorDisplayFatal
          title="Something went wrong"
          description={errorDescription}
          errors={this.state.error}
        />
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary



// WEBPACK FOOTER //
// ./src/ui/error-boundary/index.js